import { EPaymentMethodType } from '@zunta/configurations'

const paymentMethodsList = [
  {
    key: EPaymentMethodType.CREDIT_CARD,
    value: EPaymentMethodType.CREDIT_CARD,
    content: 'Credit Card'
  },
  {
    key: EPaymentMethodType.ECHECK,
    value: EPaymentMethodType.ECHECK,
    content: 'eCheck'
  },
  {
    key: 'Removed',
    value: 'Removed',
    content: 'Removed'
  }
]

export { paymentMethodsList }
